'use client';

import { useMemo } from 'react';

import type { FilmCategoryGridStoryblok } from '@utils/storyblok/storyblok';
import { Carousel } from '@common/interaction/Carousel';

import { FilmCategoryCard } from './FilmCategoryCard';

export function FilmCategoryCarousel({
  categories,
}: Pick<FilmCategoryGridStoryblok, 'categories'>) {
  const slides = useMemo(
    () =>
      categories?.map((category) => (
        <FilmCategoryCard
          key={category._uid ?? category.title}
          {...category}
        />
      )) ?? [],
    [categories],
  );

  if (!slides.length) {
    return null;
  }

  return (
    <Carousel
      controls={{ type: 'dots', isMobileVisible: true }}
      gap="4"
      options={{ dragFree: true }}
      slideSize={{ xs: '83%' }}
      slides={slides}
    />
  );
}
